<template>
  <div class="mapbox">
    <div class="closebtn" @click="$emit('goBack')">关闭 ×</div>

    <div class="imgbox">
      <img src="@/assets/images/taxpic.png" class="image" alt="税源管理图片" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TaxDetail',

  data() {
    return {}
  }
}
</script>

<style scoped>
.mapbox {
  display: flex;
  height: 100%;
  padding: 16px;
  gap: 12px;
  flex-direction: column;
}

.closebtn {
  color: #83ffe1;
  text-align: right;
  margin: 20px 15px;
  cursor: pointer;
}

.detail-img {
  width: 100%;
  height: 80%;
  object-fit: fill;
  border-radius: 8px;
  padding: 15px 20px;
}

.imgbox {
  display: flex;
  align-items: center;
  height: 80%;
  flex-wrap: wrap;
  /* padding: 0 15px; */
  /* gap: 10px; */
  justify-content: center;
}

.image {
  height: 90%;
  width: 95%;
  margin: 0 30px;
}
</style>
